import { useDragScroll } from "shared/hooks/useDragScroll";
import styles from "styles/pages/reports/reports.module.scss";

export default function AquisitionBehavior({ data = {} }) {
  const days = ["dom", "seg", "ter", "qua", "qui", "sex", "sab"];

  const rows = Object.values(data).map((item) => ({
    status: item.moment_of_day.toUpperCase(),
    values: days.map((day) => Number(item[day]) || null),
  }));

  const maxValue = Math.max(
    ...rows.flatMap((row) => row.values.filter((v) => v !== null))
  );

  const getShade = (value) => {
    if (!value || +value === 0) {
      return {
        background: "#1e1e1f",
        color: "#808080",
      };
    }

    const intensity = Math.min(Math.max(value / maxValue, 0), 1);
    const alpha = 0.6 + intensity * 1;

    return {
      background: `rgba(97, 97, 255, ${intensity})`,
      color: `rgba(255, 255, 255, ${alpha})`,
    };
  };

  const { scrollRef, onMouseDown } = useDragScroll();

  return (
    <div className={styles.box}>
      <div className="d-flex align-center gap-5">
        <p className={styles.label}>Comportamento das aquisições</p>
        <span
          className={styles.info}
          title="Quantidade de usos por momento da semana."
        >
          <i className="fal fa-info-circle" />
        </span>
      </div>

      <div className={styles.hairline} />

      <div
        className={styles.tableTransitions}
        onMouseDown={onMouseDown}
        ref={scrollRef}
      >
        <table>
          <thead>
            <tr>
              <th />
              <th style={{ width: "12.5%" }}>DOM</th>
              <th style={{ width: "12.5%" }}>SEG</th>
              <th style={{ width: "12.5%" }}>TER</th>
              <th style={{ width: "12.5%" }}>QUA</th>
              <th style={{ width: "12.5%" }}>QUI</th>
              <th style={{ width: "12.5%" }}>SEX</th>
              <th style={{ width: "12.5%" }}>SÁB</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.status}>
                <td className={styles.status} style={{ width: "12.5%" }}>
                  {row.status}
                </td>
                {row.values.map((value, idx) => {
                  const style = getShade(value);

                  return (
                    <td
                      key={idx}
                      style={{
                        backgroundColor: style.background,
                        color: style.color,
                        width: "12.5%",
                      }}
                    >
                      {value || "---"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
